export const ListHeaders = [
  {
    className: 'item-col-lgr',
    text: 'Business name',
  },
  {
    className: 'item-col-lgr',
    text: 'Website',
  },
  {
    className: 'custom-col-xsr',
    text: 'Slug',
  },
  {
    className: 'item-col-lgr',
    text: 'Max pay plan amount unconfirmed customers',
  },
  {
    className: 'item-col-lgr',
    text: 'Max pay plan amount confirmed customers',
  },
];

export const filterStatusArray = [
  {
    text: 'All',
  },
  {
    text: 'Active',
  },
  {
    text: 'Inactive',
  },
];
